// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"style_headerTitle__25g_9","line":"style_line__1iYXf","fontSize1":"style_fontSize1__DZYXt","bold":"style_bold__3PBSN"};